import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { SnackbarService } from '../../services/snackbar/snackbar.service';

export const CORS_WORKAROUND_TOKEN = new HttpContextToken<boolean>(() => false);
/**
 * Hier werden Fehler beim Senden von Requests abgefangen und für den User angezeigt.
 *
 * A_25495 -Anzeige von Fehlern beim Versand
 * @param req der Abgefangene Request
 * @param next der HttpHandlerFn
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackbar = inject(SnackbarService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Workaround TIME-2734: Remove when CORS problem for OrgAdminEndpointsService:changeDisplayname is fixed
      if (error.status === 0 && req.context.get(CORS_WORKAROUND_TOKEN)) {
        return throwError(() => error);
      }

      if (error.status >= 400 && error.status < 500) {
        snackbar.error('Es gab einen Netzwerkfehler beim Senden der Anfrage');
        console.warn(error);
        throw error;
      }
      if (error.status >= 500) {
        snackbar.error('Es gab einen Serverfehler beim Senden der Anfrage');
      }
      console.warn(error);
      throw error;
    })
  );
};
